import {
  DoryMessageType,
  DoryServiceType,
  DoryStreamingHeader,
  DoryStreamingMessage,
} from '../StreamingMessages';

//#region Ping
type DefaultPingRequest = {
  header: DoryStreamingHeader;
  payload: Record<string, never>;
} & DoryStreamingMessage;
type DefaultPingResponse = {
  header: DoryStreamingHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

function getDefaultPingRequest(): DefaultPingRequest {
  return {
    header: {
      service: DoryServiceType.DEFAULT,
      messageType: DoryMessageType.PING,
      version: 'v1',
    },
    payload: {},
  };
}

export { DefaultPingRequest, DefaultPingResponse, getDefaultPingRequest };
//#endregion

//#region RefreshToken
type DefaultRefreshTokenRequest = {
  header: DoryStreamingHeader;
  payload: {
    token: string;
  };
} & DoryStreamingMessage;
type DefaultRefreshTokenResponse = {
  header: DoryStreamingHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

function getDefaultRefreshTokenRequest(
  token: string
): DefaultRefreshTokenRequest {
  return {
    header: {
      service: DoryServiceType.DEFAULT,
      messageType: DoryMessageType.TOKENREFRESH,
      version: 'v1',
    },
    payload: {
      token,
    },
  };
}

export {
  DefaultRefreshTokenRequest,
  DefaultRefreshTokenResponse,
  getDefaultRefreshTokenRequest,
};
//#endregion

//#region Cancel
type DefaultCancelRequest = {
  payload: Record<string, never>;
} & DoryStreamingMessage;
function getDefaultCancelRequest(): DefaultCancelRequest {
  return {
    header: {
      service: DoryServiceType.DEFAULT,
      messageType: DoryMessageType.CANCEL,
      version: 'v1',
    },
    payload: {},
  };
}

export { DefaultCancelRequest, getDefaultCancelRequest };
//#endregion
//#region ConnectionsExceeded
type DefaultConnectionsExceededResponse = {
  header: DoryStreamingHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

export { DefaultConnectionsExceededResponse };
//#endregion
